import type { LooseValue } from "react-calendar/dist/esm/shared/types.js";

export default function looseValueToDate(value: LooseValue): Date | null {
  if (typeof value === "string") {
    return new Date(value);
  }
  if (value instanceof Date) {
    return value;
  }
  return null;
}
